import { authenticationService } from "@/_services";

export const requestOptions = {
  get() {
    return {
      method: "GET",
      ...headers()
    };
  },
  post(body, signal = null) {
    const config = {
      method: "POST",
      ...headers(),
      body: JSON.stringify(body)
    };
    if (signal) {
      config.signal = signal;
    }
    
    return config;
  },
  patch(body) {
    return {
      method: "PATCH",
      ...headers(),
      body: JSON.stringify(body)
    };
  },
  put(body) {
    return {
      method: "PUT",
      ...headers(),
      body: JSON.stringify(body)
    };
  },
  delete() {
    return {
      method: "DELETE",
      ...headers()
    };
  }
};

function headers() {
  // const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
  const queryString = window.location.href;
  let ob = null;
  if (queryString.split('/').length > 5 && queryString.split('/')[3] !== 'chain-dashboard') {
    if (localStorage.getItem("arrToken")) {
      ob = JSON.parse(localStorage.getItem("arrToken")).filter(e => e.hotel !== null && e.hotel.id === queryString.split('/')[4])[0];
      if (!ob) {
        window.location.href = '/login';
      }
    } else {
      window.location.href = '/login';
    }

  } else if (queryString.split('/').length > 4 && queryString.split('/')[3] === 'chain-dashboard' && localStorage.getItem("arrToken")) {
    ob = JSON.parse(localStorage.getItem("arrToken")).filter(e => e.hotel == null)[0];
    if (!ob) {
      window.location.href = '/login';
    }
  } else {
    ob = JSON.parse(localStorage.getItem("currentUser")) || {};
  }
  const currentUser = ob;
  const authHeader = currentUser.token
    ? { Authorization: "Token " + currentUser.token }
    : {};
  return {
    headers: {
      ...authHeader,
      "Content-Type": "application/json"
    }
  };
}
